module.exports = __webpack_public_path__ + "img/d.23634557.png";